"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupOverview = require("../groups-destination/GroupOverview.sync");

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _axios = _interopRequireDefault(require("axios"));

var _url = require("../../utils/url");

var _message = _interopRequireDefault(require("../design-system-components/message"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _zod = require("zod");

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'groups';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-groups';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  groups: _zod.z.array(_zod.z.object({
    id: _zod.z.number()
  })),
  buttonLabel: _zod.z.string(),
  buttonURL: _zod.z.string()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var GroupsWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupsWidget, _Component);

  var _super = _createSuper(GroupsWidget);

  function GroupsWidget() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupsWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      groups: [],
      successMessageFor: null,
      joinedGroupTitle: ''
    });
    return _this;
  }

  (0, _createClass2.default)(GroupsWidget, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var groups, res, newGroupList;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                groups = this.props.groups;
                _context.next = 3;
                return _axios.default.get('/getGroups', {
                  params: {
                    ids: groups.map(function (group) {
                      return group.id;
                    })
                  }
                });

              case 3:
                res = _context.sent;

                if (res.data && (res.data.myGroups.length || res.data.otherGroups.length)) {
                  newGroupList = groups.map(function (group) {
                    var indexOfMyList = res.data.myGroups.findIndex(function (myGroup) {
                      return myGroup.id === group.id;
                    });

                    if (indexOfMyList !== -1) {
                      return _objectSpread(_objectSpread({}, res.data.myGroups[indexOfMyList]), {
                        isUserMember: true
                      });
                    }

                    var indexOfOtherList = res.data.otherGroups.findIndex(function (myGroup) {
                      return myGroup.id === group.id;
                    });
                    if (indexOfOtherList === -1) return null;
                    return _objectSpread(_objectSpread({}, res.data.otherGroups[indexOfOtherList]), {
                      isUserMember: false
                    });
                  });
                  this.setState({
                    groups: newGroupList.filter(function (g) {
                      return g;
                    })
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          backgroundColor = _this$props.backgroundColor,
          backgroundColorDisplay = _this$props.backgroundColorDisplay,
          buttonLabel = _this$props.buttonLabel,
          buttonURL = _this$props.buttonURL,
          hideSpacingWithUpperWidget = _this$props.hideSpacingWithUpperWidget,
          paddingToTopAndBottom = _this$props.paddingToTopAndBottom,
          titleColor = _this$props.titleColor,
          titleColorDisplay = _this$props.titleColorDisplay,
          subtitleColor = _this$props.subtitleColor,
          subtitleColorDisplay = _this$props.subtitleColorDisplay;
      var _this$state = this.state,
          groups = _this$state.groups,
          successMessageFor = _this$state.successMessageFor,
          joinedGroupTitle = _this$state.joinedGroupTitle;
      var externalLink = typeof window !== 'undefined' ? (0, _url.isExternalLink)(buttonURL !== null && buttonURL !== void 0 ? buttonURL : '', window.location) : false;

      if (!groups.length) {
        return null;
      }

      return (0, _preact.h)(_widgetContainer.default, {
        config: {
          title: title,
          subtitle: subtitle,
          backgroundColor: backgroundColor,
          backgroundColorDisplay: backgroundColorDisplay,
          hideSpacingWithUpperWidget: hideSpacingWithUpperWidget,
          paddingToTopAndBottom: paddingToTopAndBottom,
          titleColor: titleColor,
          titleColorDisplay: titleColorDisplay,
          subtitleColor: subtitleColor,
          subtitleColorDisplay: subtitleColorDisplay
        },
        widgetName: widgetName
      }, successMessageFor !== null ? (0, _preact.h)(_message.default, {
        variant: "success",
        onDismiss: function onDismiss() {
          return _this2.setState({
            successMessageFor: null
          });
        },
        timer: 5000
      }, (0, _preact.h)(_phrase.default, {
        p: successMessageFor === 'joined' ? 'group.joined.successfully' : 'group.join.request.is.sent',
        count: {
          g: joinedGroupTitle
        }
      })) : null, (0, _preact.h)("div", {
        className: "group-overview"
      }, groups.map(function (group) {
        return (0, _preact.h)(_GroupOverview.GroupItem, (0, _extends2.default)({
          key: group.id,
          displayUserStatus: true,
          hasWidgetTitle: Boolean(title),
          hasWidgetSubtitle: Boolean(subtitle),
          onMembershipStatusChanged: function onMembershipStatusChanged(newMembershipStatus) {
            return _this2.setState({
              successMessageFor: newMembershipStatus
            });
          },
          isEvenCount: groups.length === 2 || groups.length === 4
        }, group, {
          origin: _GroupOverview.ORIGIN_GROUP_WIDGET,
          showGroupMeta: false
        }));
      })), buttonLabel && buttonURL && // eslint-disable-next-line react/jsx-no-target-blank
      (0, _preact.h)("a", {
        className: "featured-topics__show-more-button",
        href: (0, _absoluteUrlRuntime.resolveUrl)(buttonURL),
        target: externalLink ? '_blank' : '_self',
        rel: externalLink ? 'noreferrer noopener' : ''
      }, (0, _preact.h)(_Button.default, {
        title: buttonLabel
      })));
    }
  }]);
  return GroupsWidget;
}(_preact.Component);

exports.default = GroupsWidget;